module.exports = __webpack_public_path__ + "static/04-e7aa1cafa269cbd87f835592810ab671.jpg";